module.exports = "/_next/static/images/28aa6167639860574eacaeae27ac0b5f-medium-fastcompany.png.webp";